import { Button, type ButtonProps } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import type { FunctionComponent } from "react";

export const CancelButton: FunctionComponent<ButtonProps> = (props) => {
  return (
    <Button colorScheme="grey" variant="outline" {...props}>
      <Trans>Cancel</Trans>
    </Button>
  );
};
